import Vue from 'vue';
import Router from 'vue-router';

// Containers
const MSIContainer = () => import('@/containers/MSIContainer');

// Views
const Dashboard = () => import('@/views/Dashboard');
const CommandCentre = () => import('@/views/CommandCentre');
const Telemetry = () => import('@/views/Telemetry');
const GCUSettings = () => import('@/views/GCUSettings');
const Alerts = () => import('@/views/Alerts');
const ArmController = () => import('@/views/ArmController');

// Error Pages
const Error404 = () => import('@/views/errors/Page404');

Vue.use(Router);

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: MSIContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'commandcentre',
          name: 'Command Centre',
          component: CommandCentre
        },
        {
          path: 'telemetry',
          name: 'Telemetry',
          component: Telemetry
        },
        {
          path: 'gcusettings',
          name: 'GCUSettings',
          component: GCUSettings
        },
        {
          path: 'alerts',
          name: 'Alerts',
          component: Alerts
        },
        {
          path: 'armcontroller',
          name: 'ArmController',
          component: ArmController
        }
      ]
    },
    {
      path: '*',
      name: 'Error 404',
      component: Error404
    }
  ]
});

export default router;
